import React from "react";
import moment from "moment";
import { RaisedButton } from "material-ui";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { formatPrice, clientSideDownload, makeCsv } from "../../util";
import InlineLinkIconButton from "./inline-link-icon-button.jsx";
import debounce from "lodash/debounce";

class OrderTable extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  onClick(order) {
    if (this.props.onClick) {
      this.props.onClick(order);
    }
  }

  downloadCsv() {
    clientSideDownload(
      `eventive-${this.props.downloadCsvFileLabel}-${Date.now()}.csv`,
      "text/csv",
      makeCsv(
        this.props.orders.map(order => {
          return {
            Date: order.created_at,
            Type: order.type,
            "Customer name": order.person
              ? order.person.details.name
              : "Unknown Person",
            "Customer email": order.person ? order.person.details.email : "",
            Net: formatPrice(order.net_price || 0, {
              currency: order.currency
            }),
            Gross: formatPrice(order.purchase_price || 0, {
              currency: order.currency
            }),
            Summary: order.summary,
            "Discount code": order.coupon && order.coupon.code
          };
        })
      )
    );
  }

  _makeRowForOrder(eventBucket, order) {
    let personName = order.person
      ? order.person.details.name || order.person.details.email
      : order.type === "box_office"
      ? `Box Office (${order.subtype})`
      : order.type === "kiosk"
      ? order.kiosk.name
      : order.type === "rush_line"
      ? `Rush Line (${order.subtype})`
      : order.type === "bulk"
      ? "Bulk import"
      : order.type === "web" && order.box_office_email
      ? `Online Guest`
      : "Unknown person";
    let noWrapTdStyle = { whiteSpace: "nowrap" };

    // Fallback event bucket
    eventBucket = eventBucket || order.event_bucket.id;

    return (
      <Tr key={order.id}>
        <Td column="Event Bucket" value={order.event_bucket.name}>
          {order.event_bucket.name}
        </Td>
        <Td column="Date" value={order.created_at} style={noWrapTdStyle}>
          {moment(order.created_at).format("lll")}
        </Td>
        <Td
          column="Person"
          style={noWrapTdStyle}
          value={`${personName}${
            order.type === "rush_line" ? " (via Rush Line)" : ""
          }${order.type === "autorenewal" ? " (autorenewal)" : ""}${
            order.type === "admin_adjustment" ? " (Admin Adjustment)" : ""
          }${order.type === "instant_ticket" ? " (Instant Ticket)" : ""}`}
        >
          {order.person ? (
            <span>
              {order.person.details.name || order.person.details.email}
              {order.type === "rush_line" && <i> (via Rush Line)</i>}
              {order.type === "autorenewal" && <i> (autorenewal)</i>}
              {order.type === "admin_adjustment" && <i> (Admin Adjustment)</i>}
              {order.type === "instant_ticket" && <i> (Instant Ticket)</i>}
              <InlineLinkIconButton
                onTouchTap={() => {
                  this.onClick(order);
                  this.context.router.push(
                    `${
                      eventBucket ? `/event_buckets/${eventBucket}` : ""
                    }/people/${order.person.id}`
                  );
                }}
                tooltip="View person"
              />
            </span>
          ) : (
            personName
          )}
        </Td>
        <Td column="Amount" style={noWrapTdStyle} value={order.net_price}>
          {`${formatPrice(order.net_price || 0, {
            currency: order.platform_managed ? "usd" : order.currency
          })} (${formatPrice(
            order.purchase_price || order.original_price || 0,
            { currency: order.currency }
          )})`}
        </Td>
        <Td column="Summary" value={order.summary}>
          {order.summary}
        </Td>
        <Td column="Discount code" value={order.coupon && order.coupon.code}>
          {order.coupon && order.coupon.code}
        </Td>
        <Td column="Actions" style={noWrapTdStyle}>
          <div>
            <Link
              onClick={() => {
                this.onClick(order);
              }}
              to={`${
                eventBucket ? `/event_buckets/${eventBucket}` : ""
              }/orders/${order.id}`}
            >
              View order
            </Link>
          </div>
        </Td>
      </Tr>
    );
  }

  render() {
    let { orders, eventBucket, noSort, hideNoOrdersMessage } = this.props,
      rows = orders.map(this._makeRowForOrder.bind(this, eventBucket));

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={
            noSort
              ? false
              : [
                  { column: "Date", sortFunction: Sort.Date },
                  "Person",
                  "Amount"
                ]
          }
          defaultSort={{ column: "Date", direction: "desc" }}
          columns={(this.props.showEventBucket ? ["Event Bucket"] : [])
            .concat(["Date"])
            .concat(this.props.isSinglePerson ? [] : ["Person"])
            .concat([{ key: "Amount", label: "Amount (net/paid)" }, "Summary"])
            .concat(this.props.showCouponCode ? ["Discount code"] : [])
            .concat(["Actions"])}
          filterable={[
            "Event Bucket",
            "Date",
            "Person",
            "Discount code",
            "Summary"
          ]}
          filterPlaceholder="Type to filter..."
          filterBy={
            this.props.location && this.props.location.query.order_filter
          }
          onFilter={
            this.props.location &&
            debounce(
              f =>
                this.context.router.push(
                  Object.assign({}, this.props.location, {
                    query: Object.assign(this.props.location.query, {
                      order_filter: f || undefined
                    })
                  })
                ),
              250
            )
          }
        >
          {rows}
        </Table>
        {rows.length === 0 && !hideNoOrdersMessage ? (
          <div className="empty-table-message">No orders yet.</div>
        ) : null}
        {this.props.showDownloadButton ? (
          <RaisedButton
            style={{ marginTop: 10 }}
            label="Download (.csv)"
            onTouchTap={this.downloadCsv}
          />
        ) : null}
      </div>
    );
  }
}

export default OrderTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/order-table.jsx